export default {
    styleOverrides: { root: {
      
   
    }
  }
  };